import { lazy, Suspense } from "react";

import { LoadingIndicatorFullPage } from "../../../cc-ui/components";

const RoomSupervisorPage = lazy(() =>
  import("./RoomSupervisorPage").then((module) => ({ default: module.RoomSupervisorPage })),
);

export function RoomSupervisorAsync() {
  return (
    <Suspense fallback={<LoadingIndicatorFullPage open />}>
      <RoomSupervisorPage />
    </Suspense>
  );
}
